import { forwardRef } from 'react';

/**
 * Token-styled input. Pass invalid={true} to flag format errors with red outline.
 * onBlur is forwarded; autosave is disabled, so blur does not save.
 */
const Input = forwardRef(
  /**
   * @param {{ invalid?: boolean, disabled?: boolean, style?: any, [key: string]: any }} props
   * @param {any} ref
   */
  function Input(
    { invalid = false, disabled = false, className: callerClassName, style, ...rest },
    ref,
  ) {
  return (
    <input
      ref={ref}
      disabled={disabled}
      className={`ab-input${callerClassName ? ' ' + callerClassName : ''}`}
      style={{
        width: '100%',
        padding: '6px 10px',
        fontSize: 'var(--ab-text-sm)',
        fontFamily: 'var(--ab-font-sans)',
        color: 'var(--ab-fg)',
        background: disabled ? 'var(--ab-bg-input)' : 'var(--ab-bg)',
        border: invalid ? '1.5px solid var(--ab-denied)' : '1px solid var(--ab-fg)',
        borderRadius: 'var(--ab-radius-sm)',
        outline: 'none',
        height: 34,
        ...style,
      }}
      {...rest}
    />
  );
});

export default Input;
